import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { goToWaitlist } from "@/lib/site";

const KEY = "cl-announce-dismissed";
const BAR_H = 38;

export const useAnnouncement = () => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem(KEY) === "1") return;
    const t = setTimeout(() => setShown(true), 250);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    document.documentElement.style.setProperty("--cl-bar-h", shown ? `${BAR_H}px` : "0px");
  }, [shown]);
  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setShown(false);
  };
  return { shown, dismiss };
};

export const AnnouncementBar = ({ shown, onDismiss }) => (
  <div
    className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out ${
      shown ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
    }`}
    aria-hidden={!shown}
    inert={shown ? undefined : ""}
  >
    <div className="overflow-hidden">
      <div
        data-testid="announcement-bar"
        role="region"
        aria-label="Announcement"
        className="announce-bar relative flex h-[38px] items-center justify-center px-9 sm:px-14"
      >
        <p className="relative z-10 whitespace-nowrap text-[9.5px] font-medium uppercase tracking-[0.12em] text-[#030507] sm:text-[10.5px] sm:tracking-[0.26em]">
          <span aria-hidden="true">✦ </span>Launching soon<span className="hidden sm:inline"> on iOS &amp; Android</span> —{" "}
          <a
            href="#launching-soon"
            onClick={goToWaitlist}
            tabIndex={shown ? 0 : -1}
            data-testid="announcement-waitlist-link"
            className="font-semibold underline decoration-[#030507]/30 underline-offset-[3px] transition-colors hover:decoration-[#030507]"
          >
            Join the waitlist →
          </a>
        </p>
        <button
          type="button"
          aria-label="Dismiss"
          tabIndex={shown ? 0 : -1}
          onClick={onDismiss}
          data-testid="announcement-dismiss-button"
          className="absolute right-2 z-10 inline-flex h-7 w-7 items-center justify-center rounded-full text-[#030507]/70 transition-colors hover:bg-[#030507]/10 hover:text-[#030507] sm:right-4"
        >
          <X size={14} strokeWidth={1.6} />
        </button>
      </div>
    </div>
  </div>
);
